if (!customElements.get('cart-variant-updater')) {
  class cartVariantUpdater extends HTMLElement {
    constructor() {
      super();
      this.index = this.dataset.index;
      this.currentVariantId = this.dataset.variantId;
      this.selectedVariantId = this.currentVariantId;
      this.productUrl = this.dataset.productUrl;
      this.quantityMismatchText = window.ntw?.quantityMismatchText;

      this.input = this.querySelector('input');
      this.select = this.querySelector('.cart-variant-updater .variant-select');
      this.spinner = this.closest('tr')?.querySelector('.loading__spinner');
      this.lineErrorTextContainer = this.parentElement?.querySelector('.cart-item__error');
      this.lineErrorText = this.parentElement?.querySelector('.cart-item__error .cart-item__error-text');

      this.select?.addEventListener('change', this.onVariantChange.bind(this));
      this.querySelectorAll('.quantity__button').forEach((button) =>
        button.addEventListener('click', this.onQuantityButtonsClick.bind(this))
      );


    }

    connectedCallback() {
      this.validateQtyRules();

      if (this.quantityMismatchText?.line && this.quantityMismatchText.line == this.index) {
        this.showLineItemErrorMessage(window.ntw.quantityMismatchText.text);
      }
    }

    onVariantChange(event) {
      event.preventDefault();
      event.stopPropagation();
      let quantityToAdd = this.validateQuantityToAdd(event);
      if (this.selectedVariantId !== this.currentVariantId) {
        this.switchVariant(quantityToAdd);
      }
    }

    validateQuantityToAdd(event) {
      const selectedOption = event.target.selectedOptions[0];
      const inventory = selectedOption.dataset.inventory;
      this.selectedVariantId = event.target.value;

      const quantity = parseInt(this.input.value, 10);
      let quantityToAdd = quantity;
      if (quantity > inventory) {
        quantityToAdd = inventory;
        window.ntw.quantityMismatchText = { line: this.index, text: `Due to availability only ${inventory} added` };
      }
      return quantityToAdd;
    }

    onQuantityButtonsClick(event) {
      event.preventDefault();
      if (event.currentTarget.classList.contains('disabled')) {
        return this.showLineItemErrorMessage("Max quantity already added to cart");
      }

      const buttonName = event.currentTarget.name;
      const previousValue = this.input.value;

      if (buttonName === 'plus') {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
        const inputValue = parseInt(this.input.value);
        this.updateQuantity(inputValue);
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value, 10);
      if (this.input.dataset.min) {
        const btnMinus = this.querySelector("button[name='minus']");
        btnMinus?.classList.toggle('disabled', value <= parseInt(this.input.dataset.min));
      }
      if (this.input.dataset.max) {
        const btnPlus = this.querySelector("button[name='plus']");
        btnPlus?.classList.toggle('disabled', value >= parseInt(this.input.dataset.max));
      }
    }

    async updateQuantity(quantity) {
      try {
        this.showSpinner()

        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: this.currentVariantId,
            quantity,
            sections: this.getSectionsToRender().map((s) => s.section),
            sections_url: this.productUrl,
          }),
        });

        const data = await res.json();
        this.updateSectionsFromResponse(data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        console.error('Quantity update failed:', err);
      }
      finally {
        this.hideSpinner();
      }
    }

    async switchVariant(quantity) {
      const updates = {
        [this.currentVariantId]: 0,
        [this.selectedVariantId]: quantity,
      };

      try {
        this.showSpinner();

        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates,
            sections: this.getSectionsToRender().map((s) => s.section),
            sections_url: this.productUrl,
          }),
        });

        const data = await res.json();

        this.currentVariantId = this.selectedVariantId;
        this.dataset.variantId = this.selectedVariantId;

        this.updateSectionsFromResponse(data.sections);

      } catch (err) {
        console.error('Variant switch failed:', err);
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      const fragment = document.createElement('div');
      fragment.innerHTML = html;

      return selector ? fragment.querySelector(selector)?.innerHTML : html;
    }

    updateSectionsFromResponse(sections) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !sections[section.section]) {
          return;
        }

        const newInnerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
        if (newInnerHTML.includes('is-empty')) {
          document.querySelector("cart-drawer").classList.add("is-empty")
        }

        if (section.selector) {
          const target = container.querySelector(section.selector);
          if (target) target.innerHTML = newInnerHTML;
        } else {
          container.innerHTML = newInnerHTML;
        }
      });

      document.dispatchEvent(new CustomEvent('cart:refreshed'));
    }


    getSpinnerElement() {
      return this.closest('tr')?.querySelector('.loading__spinner');
    }

    showSpinner() {
      if (this.spinner) this.spinner.classList.remove('hidden');
    }

    hideSpinner() {
      if (this.spinner) this.spinner.classList.add('hidden');
    }

    showLineItemErrorMessage(message) {
      this.lineErrorText.textContent = message;
      this.lineErrorTextContainer.classList.remove('hidden');
      return setTimeout(() => {
        this.lineErrorTextContainer.classList.add('hidden');
        window.ntw.quantityMismatchText = {
          line: null,
          text: '',
        };
      }, 3500);
    }
  }

  customElements.define('cart-variant-updater', cartVariantUpdater);
}
